// src/config/apiConfig.js

// API URL DOMAIN
// export const API_DOMAIN = 'http://localhost:'; 
export const API_DOMAIN = 'https://api.vv-trip.com:';

// ONBOARD API URL
export const API_ONBOARD_URL = `${API_DOMAIN}8001/userAPI`;
export const API_ROUTES_ONBOARD = {
    user: '/users/',
    userByCognitoId: '/users/cognito/',
    profile: '/user-profiles/',
    profileByCognitoId: '/user-profiles/cognito/',
    profileUpdate: '/profileUpdate/',

    // admin routes
    AdminUser: '/admin-users/',
   
};

// TRIP API URL
export const API_TRIP_URL = `${API_DOMAIN}8000/tripAPI`;
export const API_ROUTES_TRIP = {
    trips: '/trips/',
    tripsByCognitoId: '/trips/cognitoUser/',
    currentUpcomming: '/trips/dashboardTrip/',
    createTrip: '/tripsDataImage/',
    updateTrip: '/tripsDataImage/',
    deleteTrip: '/tripsDataImageDelete/',
    tripsWithProfile: '/tripsWithProfile/',
    cancelTrip: '/cancel-trip/',
    updateTripImage: '/updateTripImage/',
};

// TRIP INVITE API URL
export const API_TRIP_INVITE_URL = `${API_DOMAIN}8003/inviteAPI`;
export const API_ROUTES_TRIP_INVITE = {
    tripInvitation: '/invite/',
    tripInvitationByCognitoId: '/invite/tripInvitations/',
    tripInvitationJoin: '/invite/tripTravelers/',
    tripTravelers: '/invite/tripTravelers/',
    joinedTripByCognitoId: '/invite/tripTravelers/',
    travelersByTripId: '/invite/tripTravelersByTrip/',
    tripJoinRequest: '/invite/tripJoinRequests/',
    tripJoinRequestByTripOwner: '/invite/tripJoinRequests/',
};

// TRIP GALLERY API URL
export const API_TRIP_GALLERY_URL = `${API_DOMAIN}8005/galleryAPI`;
export const API_ROUTES_TRIP_GALLERY = {
    tripGallery: '/tripgallery/',
    tripGalleryByTripId: '/tripgallery/tripId/',
    tripGalleryMedia: '/tripMedia/',
    gallerySummary: '/gallerySummary/',
    tripMediaList: '/tripMediaList/',
};

// ADD FRIEND API URL
export const API_ADD_FRIEND_URL = `${API_DOMAIN}8008/friendAPI`;
export const API_ROUTES_ADD_FRIEND = {
    addFriend: '/friendrequest/',
    friendRequests: '/friendrequest/cognito/',
    userFriends: '/userfriends/',
    userFriendsByCognitoId: '/userfriends/cognito/',
};

// User Preferences API URL
export const API_USER_PREFERENCES_URL = `${API_DOMAIN}8010/preferencesAPI`;
export const API_ROUTES_USER_PREFERENCES = {
    userPreferences: '/userpreferences/',
    userPreferencesByCognitoId: '/userpreferences/cognito/',
};

// POST API URL
export const API_POST_URL = `${API_DOMAIN}8014/postAPI`;
export const API_ROUTES_POST = {
    posts: '/posts/',
    createPost: '/createPost/',
};

// Notification API URL
export const NOTIFICATION_API_URL = `${API_DOMAIN}8016/notificationAPI`;
export const API_ROUTES_NOTIFICATION = {
    registerDeviceToken: '/register-device-token/',
    friendRequest: '/friend-request/',
    tripInvitation: '/trip-invitation/',
    tripJoinRequest: '/trip-join-request/',
    tripEdit: '/trip-edit/',
    tripCancel: '/trip-cancel/',
    tripJoinApprovalRejection: '/trip-join-approval-rejection/',
};
